module.exports = __webpack_public_path__ + "static/8-c8a49cd1fc7578b52aa631320b87d754.jpeg";